<template>
    <el-popover :value="ready && !!tooltips.length"
                :disabled="!tooltips.length"
                trigger="manual"
                placement="left">
        <!-- Content -->
        <template #reference>
            <slot />
        </template>

        <!-- Tooltips -->
        <template #default>
            <div class="max-w-16 space-y-1">
                <!-- Items -->
                <div class="space-y-0.5">
                    <div v-for="x in tooltips"
                         :key="x.id"
                         class="space-y-0.5">
                        <!-- Warnings -->
                        <is-label v-for="y in x.warnings"
                                  :key="y"
                                  :value="y"
                                  text-class="text-left"
                                  :color="x.failed && 'red' || null" />

                        <!-- Messages -->
                        <is-label v-for="y in x.messages"
                                  :key="y"
                                  :value="y"
                                  text-class="text-left" />
                    </div>
                </div>

                <!-- Actions -->
                <div class="f-x-end">
                    <el-button type="primary"
                               size="mini"
                               @click="() => ready = false">
                        {{ labels.ok }}
                    </el-button>
                </div>
            </div>
        </template>
    </el-popover>
</template>

<script>
const labels = {
  ok: 'Понятно'
}

export default {
  props: {
    tooltips: { type: Array, default: () => [] }
  },
  data() {
    return {
      ready: false
    }
  },
  computed: {
    labels() {
      return {
        ...labels
      }
    }
  },
  watch: {
    tooltips() {
      this.ready = true
    }
  },
  mounted() {
    this.ready = true
  }
}
</script>
